// *** Main *** //

export const ADD_OPERATION = "ADD_OPERATION";
export const DELETE_OPERATION = "DELETE_OPERATION";

// ***  *** //
